import cookie from 'react-cookie';
import { PageExperiments } from '@letsdothis/experiments';
import { digestCookies } from '@letsdothis/quarantine';
import { Tracking, SourceType } from '@letsdothis/tracking';

import { CAMPAIGN_COOKIE_NAME } from '@services/tracking';
import { getLocationInfoForCurrentUser } from '@utils/ipstack';

const getPageExperiments = () => {
  if (!__CLIENT__) return { serverside: true };
  const url = window.location.href;
  return PageExperiments.getExperimentsFromUrl(url);
};

let userLocationInfo: any;
if (__CLIENT__) {
  // Set location info once request returns.
  getLocationInfoForCurrentUser()
    .then((locInfo) => {
      // Do not allow properties of userLocationInfo to be changed once it's set.
      userLocationInfo = Object.freeze(locInfo);
    })
    .catch(() => {
      userLocationInfo = Object.freeze({});
    });
}

export const tracking = (): Tracking =>
  new Tracking(
    __CLIENT__
      ? [
          {
            type: SourceType.SEGMENT,
            source: window?.analytics,
            context: () => ({
              campaign: cookie.load(CAMPAIGN_COOKIE_NAME),
              location: userLocationInfo,
              experiments: digestCookies(cookie.select()),
              pageExperiments: getPageExperiments(),
            }),
          },
        ]
      : [],
  );
